import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { StyledTypography } from "components/StyledComponents/styledComponents.js";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  TextField,
  TableHead,
  Typography,
  Box,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import Autocomplete from "@mui/material/Autocomplete";
import {
  StyledButton,
  StyledAlert,
  StyledSnackbar,
  inputStyle,
  ViewButton,
  DeleteButton,
  StyledTableContainer,
  StyledButtonC,
  CustomTableCell,
  StyledAgGridContainer,
} from "components/StyledComponents/styledComponents.js";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { CustomPaper } from "components/Styles/globalStyles";
import Cookie from "js-cookie";
import { json, useNavigate } from "react-router-dom";
import URLs from "constants/urls";
import AddIcon from "@mui/icons-material/AddTask";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useMaterialUIController } from "context";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import styled from "@mui/material/styles/styled";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import InfoIcon from "@mui/icons-material/Info";
import CalculateIcon from "@mui/icons-material/Calculate";
import SaveIcon from "@mui/icons-material/Save";
// import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const StyledCloseButton = styled(Button)({
  backgroundColor: "#f5f5f5",
  color: "#666",
  marginRight: "10px",
  "&:hover": {
    backgroundColor: "#e0e0e0",
  },
});

export default function PayStructureMappingToEmployee() {
  const [controller] = useMaterialUIController(); // Get context state
  const { user } = controller; // Destructure user
  const [companyCode, setCompanyCode] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [structureData, setStructureData] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeName, setEmployeeName] = useState("");
  const [hiringDate, setHiringDate] = useState(new Date().toISOString().split("T")[0]);
  const [employeeData, setEmployeeData] = useState([]);
  const [unmappedEmployeeData, setUnmappedEmployeeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payStructures, setPayStructures] = useState([]);
  const [structureType, setStructureType] = useState("");
  const [structureName, setStructureName] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [value, setValue] = useState("");
  const hrms_token = Cookie.get("hrms_token");
  const [payStructId, setPayStructId] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [filteredStructures, setFilteredStructures] = useState([]);
  const [comapanyStructures, setCompanyStructures] = useState([]);
  const [employeePayMapId, setEmployeePayMapId] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openStructureDialog, setOpenStructureDialog] = useState(false);
  const [dialogStructureData, setDialogStructureData] = useState([]);
  const [totalCtc, setTotalCtc] = useState(0);

  const tabs = [{ label: "Structure Mapping" }, { label: "Mapped Structures" }];

  const columnDefs = [
    {
      headerName: "Applicant Name",
      field: "employeeName",
      sortable: true,
      filter: true,
      flex: 2,
      cellStyle: { fontWeight: "500" },
    },
    {
      headerName: "Actions",
      field: "actions",
      sortable: false,
      filter: false,
      width: 120,
      cellRenderer: (params) => (
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <ViewButton onClick={() => handleEditStructure(params.node.rowIndex)}>
            <EditIcon />
          </ViewButton>
          <DeleteButton onClick={() => handleOpenDialog(params.data)}>
            <DeleteIcon />
          </DeleteButton>
        </Box>
      ),
    },
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      filter: true,
      flex: 1,
      cellStyle: { fontWeight: "500" },
    },
  ];

  const columnDefsTab1 = [
    {
      headerName: "Applicant Name",
      field: "employeeName",
      sortable: true,
      filter: true,
      flex: 2,
      cellStyle: { fontWeight: "500" },
    },
    {
      headerName: "Hiring Date",
      field: "hiringDate",
      sortable: true,
      filter: true,
      flex: 1.5,
      valueFormatter: (params) => formatDate(params.value) || "",
      cellStyle: { fontWeight: "500" },
    },
    {
      headerName: "CTC Per Year",
      field: "ctcPerYear",
      sortable: true,
      filter: true,
      flex: 1.5,
      valueFormatter: (params) =>
        params.value ? `₹ ${formatNumberWithCommas(params.value.toFixed(2))}` : "",
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },
    {
      headerName: "Actions",
      field: "actions",
      sortable: false,
      filter: false,
      width: 120,
      cellRenderer: (params) => (
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <StyledButton
            variant="contained"
            size="small"
            onClick={() => handlePostDetails(params.data)}
          >
            Add
          </StyledButton>
        </Box>
      ),
    },
  ];

  const handleTabChange = (event, newValue) => {
    resetFormData();
    setTabValue(newValue);
  };

  const resetFormData = () => {
    setSelectedEmployee(null);
    setEmployeeName("");
    setHiringDate(new Date().toISOString().split("T")[0]);
    setStructureData([]);
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setPayStructId(0);
    setEditMode(false);
  };

  const resetForm = () => {
    setCompanyCode("");
    setSelectedCompany(null);
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setStructureData([]);
    setSelectedEmployee(null);
    setEmployeeName("");
    setHiringDate("");
    setEmployeeData([]);
  };

  const jwt_token = Cookie.get("jwt_token");
  const navigate = useNavigate();
  const MInput = inputStyle();

  const structureTypeOptions = [
    { label: "ADDITION", value: "ADDITION" },
    { label: "DEDUCTION", value: "DEDUCTION" },
  ];

  const dropdownOptions = [
    { label: "FIXED", value: "FIXED" },
    { label: "PERCENT", value: "PERCENT" },
  ];

  const fetchApplicants = async () => {
    try {
      setLoading(true);
      const response = await fetch(URLs.hrmsGetAllApplicants, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hrms_token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Failed to fetch applicants: ${response.status}`);
      }

      const data = await response.json();
      // Map the applicant data to match the expected employee data structure
      const mappedData = data.map((applicant) => ({
        employeeRecordId: applicant.applicantId,
        employeeName: `${applicant.firstName || ""} ${applicant.lastName || ""}`.trim(),
        hiringDate: applicant.dateOfJoining
          ? Array.isArray(applicant.dateOfJoining)
            ? applicant.dateOfJoining.join("-")
            : applicant.dateOfJoining
          : "",
        role: { roleId: applicant.roleId },
        phoneNumber: applicant.phoneNumber || "",
        emailId: applicant.emailId || "",
        ctcPerYear: applicant.ctcPerYear || 0,
        basic: applicant.basic || 0,
        companyId: applicant.companyId,
        address: [
          applicant.doorNo,
          applicant.streetName,
          applicant.cityName,
          applicant.districtName,
          applicant.stateName,
          applicant.zipCode,
        ]
          .filter(Boolean)
          .join(", "),
      }));
      setEmployeeData(mappedData);
      setUnmappedEmployeeData(mappedData); // Set all applicants as unmapped
    } catch (error) {
      console.error("Error fetching applicants:", error);
      setAlert(error.message || "Failed to fetch applicants", "error");
      setEmployeeData([]);
      setUnmappedEmployeeData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchPayStruData = async () => {
    const url = `${URLs.hrmsPayStructsByCid}/${user.companyId}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${hrms_token}`,
      },
    };

    setLoading(true);
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`Failed to fetch company structures: ${response.status}`);
      }

      const data = await response.json();
      setCompanyStructures(data);
    } catch (error) {
      console.error("Error fetching company structures:", error);
      setAlert("Failed to fetch Pay Structure data", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchMappedStructures = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${URLs.hrmsGetAllApplicantsPayStructures}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hrms_token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch mapped structures");
      }

      const data = await response.json();

      // Find matching employees from employeeData for complete information
      const formattedData = data.map((item) => {
        const matchingEmployee = employeeData.find(
          (emp) => emp.employeeRecordId === item.applicantId
        );

        return {
          employeeName: matchingEmployee
            ? matchingEmployee.employeeName
            : `${item.firstName || ""} ${item.lastName || ""}`.trim(),
          applicantId: item.applicantId,
          status: item.status || "Active",
          // Store original data for reference
          firstName: item.firstName,
          lastName: item.lastName,
          // Add additional employee data if needed
          ctcPerYear: matchingEmployee?.ctcPerYear,
          basic: matchingEmployee?.basic,
        };
      });

      // Remove these applicants from unmappedEmployeeData
      const mappedIds = formattedData.map((item) => item.applicantId);
      setUnmappedEmployeeData((prev) =>
        prev.filter((emp) => !mappedIds.includes(emp.employeeRecordId))
      );

      setStructureData(formattedData);
      setMessage("Mapped structures fetched successfully");
      setAlertType("success");
      setOpen(true);
    } catch (error) {
      console.error("Error fetching mapped structures:", error);
      setMessage(error.message || "Failed to fetch mapped structures");
      setAlertType("error");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedEmployee) {
      setEmployeeName(`${selectedEmployee.employeeName}`);
      setHiringDate(selectedEmployee.hiringDate);
    } else {
      setEmployeeName("");
      setHiringDate("");
      setStructureData([]);
    }
  }, [selectedEmployee]);

  useEffect(() => {
    if (structureType) {
      const filtered = comapanyStructures
        .filter((struct) => struct.structType === structureType)
        .map((struct) => ({
          label: struct.structName,
          value: struct.payStructId,
          type: struct.structPercentFixedType.trim(),
          amount: struct.structValue,
        }));
      setFilteredStructures(filtered);
    }
  }, [structureType, comapanyStructures]);

  useEffect(() => {
    if (tabValue === 1) {
      fetchMappedStructures();
    }
  }, [tabValue]);

  useEffect(() => {
    fetchApplicants();
    fetchPayStruData();
  }, []);

  const calculateAmount = (structName, value, type, basic) => {
    const val = parseFloat(value) || 0;
    const basicSalary = parseFloat(basic) || 0;

    // Special calculation for Employer PF
    if (structName === "Employer PF") {
      if (type === "FIXED") {
        return val;
      }

      if (type === "PERCENT") {
        const bSalary = basicSalary;
        return bSalary <= 180000 ? (bSalary * value) / 100 : (180000 * value) / 100;
      }
    }

    // Default calculation for other structures
    if (type === "FIXED") {
      return val;
    }

    if (type === "PERCENT") {
      return (basicSalary * val) / 100;
    }

    return 0;
  };

  const updateTotalCtc = (structures) => {
    const structuresTotal = structures.reduce((sum, item) => {
      return sum + (item.amount || 0);
    }, 0);
    setTotalCtc(structuresTotal);
  };

  const handleAddToTable = () => {
    if (!structureType || !structureName || !dropdownValue || !value) {
      setAlert("Please fill in all fields", "error");
      return;
    }

    let baseAmount =
      structureName == "Basic Salary"
        ? selectedEmployee?.ctcPerYear || 0
        : selectedEmployee?.ctcPerYear * 0.5 || 0;
    const amount = calculateAmount(structureName, value, dropdownValue, baseAmount);
    const newStructure = {
      structureType,
      structureName,
      percentFixed: dropdownValue,
      value,
      amount,
      payStructId,
      // Include IDs for both new and edit modes
      applPayStructMapId: window.editingRow?.applPayStructMapId || 0,
      applicantId: selectedEmployee?.employeeRecordId,
    };

    const newData = [...dialogStructureData, newStructure];
    setDialogStructureData(newData);
    updateTotalCtc(newData);

    // Reset structure form fields
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setPayStructId(0);
    window.editingRow = null; // Clear the editing row data

    // Ensure we stay in post mode if we're in first tab
    if (tabValue === 0) {
      setEditMode(false);
    }
  };

  const handleRemoveFromTable = (index) => {
    const newData = dialogStructureData.filter((_, i) => i !== index);
    setDialogStructureData(newData);
    updateTotalCtc(newData);
  };

  const handleAddStructure = async () => {
    if (dialogStructureData.length === 0) {
      setAlert("Please add at least one structure", "error");
      return;
    }

    // 5% maintaing....for posting.
    const targetCtc = selectedEmployee?.ctcPerYear || 0;
    const minCtc = targetCtc * 0.95; // 5% below
    const maxCtc = targetCtc * 1.05; // 5% above

    if (totalCtc < minCtc || totalCtc > maxCtc) {
      setAlert("Total CTC must be within ±5% of the applicant's CTC", "error");
      return;
    }

    setLoading(true);

    try {
      if (editMode) {
        // For update, send all structures in a single request
        // Format the update payload as an array of structures
        const structures = dialogStructureData.map((structure) => {
          return {
            applPayStructMapId: structure.applPayStructMapId || 0, // Use 0 if ID is missing
            applicantId: selectedEmployee.employeeRecordId,
            payStructId: structure.payStructId,
            structValue:
              structure.percentFixed === "PERCENT" ? parseFloat(structure.value) : structure.amount,
            activeStatus: "Y",
          };
        });

        const response = await fetch(
          `${URLs.hrmsUpdateApplicantPayStruct}/${selectedEmployee.employeeRecordId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${hrms_token}`,
            },
            body: JSON.stringify(structures),
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to update structures");
        }
      } else {
        // For new structures, create them one by one
        const promises = dialogStructureData.map((structure) => {
          const payload = {
            applicantId: selectedEmployee.employeeRecordId,
            payStructId: structure.payStructId,
            structValue:
              structure.percentFixed === "PERCENT" ? parseFloat(structure.value) : structure.amount,
            activeStatus: "Y",
          };

          return fetch(URLs.hrmsPostPayStructMapping, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${hrms_token}`,
            },
            body: JSON.stringify(payload),
          });
        });

        await Promise.all(promises);
      }

      handleCloseStructureDialog();
      setAlert(
        editMode ? "Structures updated successfully" : "Structures added successfully",
        "success"
      );

      // After successful addition/update, refresh the mapped structures
      await fetchMappedStructures();

      // Remove the mapped applicant from unmappedEmployeeData if this is a new mapping
      if (!editMode) {
        setUnmappedEmployeeData((prev) =>
          prev.filter((emp) => emp.employeeRecordId !== selectedEmployee.employeeRecordId)
        );
      }

      setTabValue(1); // Switch to mapped structures tab
    } catch (error) {
      console.error("Error:", error);
      setAlert(error.message || `Failed to ${editMode ? "update" : "add"} structures`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleStructureNameChange = (event, selectedOption) => {
    if (selectedOption) {
      setStructureName(selectedOption.label);
      setDropdownValue(selectedOption.type);
      setPayStructId(selectedOption.value);
      setValue(selectedOption.amount?.toString() || "");
    } else {
      setStructureName("");
      setDropdownValue("");
      setValue("");
      setPayStructId("");
    }
  };

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const restFormInputs = () => {
    setEditMode(false);
    setPayStructId("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setStructureType("");
    setEmployeePayMapId("");
  };
  const handleEditStructure = async (index) => {
    const newStructure = structureData[index];
    setEditMode(true);
    setLoading(true);

    try {
      // Find the employee from employeeData based on the name
      const matchingEmployee = employeeData.find(
        (emp) => emp.employeeRecordId === newStructure.applicantId
      );

      if (!matchingEmployee) {
        setAlert("Employee not found", "error");
        return;
      }

      // Set the selected employee first
      setSelectedEmployee(matchingEmployee);

      // Store the applicantId for later use
      window.currentApplicantId = newStructure.applicantId;

      // Fetch existing structure data using the new API endpoint
      const response = await fetch(
        `${URLs.hrmsGetPayStructDetailsById}/${newStructure.applicantId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${hrms_token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch structure details");
      }

      const structureDetails = await response.json();

      // Format the structure data for the dialog
      const formattedStructures = structureDetails
        .map((structure) => {
          // Map the fields from the API response - using both possible field names
          const structType = structure.structType || structure.structureType || "";
          const structName = structure.structName || structure.structureName || "";
          const percentFixedType =
            structure.structPercentFixedType || structure.percentFixedType || "FIXED";
          const structValue = parseFloat(structure.structValue || structure.value || 0);
          const payStructId = parseInt(structure.payStructId || structure.payStructureId || 0, 10);
          const applPayStructMapId = parseInt(structure.applPayStructMapId || 0, 10);
          const applicantId = window.currentApplicantId;

          // Ensure we have valid numeric values
          if (isNaN(structValue) || isNaN(payStructId)) {
            console.warn("Invalid numeric value in structure:", structure);
            return null;
          }
          ctcPerYear;
          let baseAmount =
            structureName == "Basic Salary"
              ? matchingEmployee?.ctcPerYear || 0
              : matchingEmployee?.ctcPerYear * 0.5 || 0;
          const amount = calculateAmount(
            structName,
            structValue,
            percentFixedType.trim(),
            parseFloat(baseAmount)
          );

          // First try to find a matching structure in companyStructures
          const matchingStructure = comapanyStructures.find(
            (s) => s.payStructId === payStructId || s.structName === structName
          );

          // Use the matching structure's type if available, otherwise use the API response
          const finalStructType = matchingStructure?.structType || structType;

          return {
            structureType: finalStructType,
            structureName: structName,
            percentFixed: percentFixedType.trim(),
            value: structValue,
            amount: amount,
            payStructId: payStructId,
            applPayStructMapId: applPayStructMapId,
            applicantId: applicantId,
          };
        })
        .filter(Boolean); // Remove any null entries

      // Set the dialog data
      setDialogStructureData(formattedStructures);

      // Calculate total CTC including basic pay
      const structuresTotal = formattedStructures.reduce(
        (sum, item) => sum + (item.amount || 0),
        0
      );
      const totalWithBasic = structuresTotal;
      setTotalCtc(totalWithBasic);

      // Open the dialog
      setOpenStructureDialog(true);
    } catch (error) {
      console.error("Error fetching structure details:", error);
      setAlert(error.message || "Failed to load structure details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteStructure = async () => {
    if (!selectedRow?.applicantId) {
      setAlert("Invalid applicant ID", "error");
      return;
    }

    setLoading(true);

    try {
      const url = `${URLs.hrmsDeletePayStructMapping}/${selectedRow.applicantId}`;

      const options = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hrms_token}`,
        },
      };

      const response = await fetch(url, options);

      if (!response.ok) {
        let errorMessage;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message;
        } catch (e) {
          errorMessage = `Failed to delete structure mapping: ${response.status}`;
        }
        throw new Error(errorMessage);
      }

      setAlert("Structure mapping deleted successfully", "success");
      handleCloseDialog();

      // Add the deleted applicant back to unmappedEmployeeData
      const deletedEmployee = employeeData.find(
        (emp) => emp.employeeRecordId === selectedRow.applicantId
      );
      if (deletedEmployee) {
        setUnmappedEmployeeData((prev) => [...prev, deletedEmployee]);
      }

      // Refresh the data after successful deletion
      await fetchMappedStructures();

      // Reset any selected items
      setSelectedRow(null);
    } catch (error) {
      console.error("Error deleting structure mapping:", error);
      setAlert(error.message || "Failed to delete structure mapping", "error");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleOpenDialog = (rowData) => {
    setSelectedRow(rowData);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const handleCloseStructureDialog = () => {
    setOpenStructureDialog(false);
    setDialogStructureData([]);
    setTotalCtc(0);
    setEditMode(false); // Reset edit mode when closing dialog
    window.editingRow = null; // Clear editing row data

    // Reset form fields
    setStructureType("");
    setStructureName("");
    setDropdownValue("");
    setValue("");
    setPayStructId(0);
  };

  const handleValueChange = (e) => {
    const rawValue = e.target.value.replace(/[^\d.]/g, "");
    const numericValue = parseFloat(rawValue);
    if (!isNaN(numericValue)) {
      setValue(rawValue);
    } else if (rawValue === "" || rawValue === ".") {
      setValue(rawValue);
    }
  };

  const handlePostDetails = (rowData) => {
    setSelectedEmployee(rowData);
    setEmployeeName(rowData.employeeName);
    setHiringDate(rowData.hiringDate);
    setEditMode(false);
    setOpenStructureDialog(true);
    setDialogStructureData([]); // Clear any existing structure data
  };

  const formatNumberWithCommas = (value) => {
    if (value === null || value === undefined) return "";
    // Convert to string if it's a number
    const stringValue = value.toString();
    // Remove any existing commas and non-numeric characters except decimal point
    const numericValue = stringValue.replace(/[^\d.]/g, "");
    // Format with commas
    const parts = numericValue.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  const handleEditTableRow = (index) => {
    const row = dialogStructureData[index];
    // Store all necessary IDs in window.editingRow
    window.editingRow = {
      applPayStructMapId: row.applPayStructMapId,
      payStructId: row.payStructId,
      applicantId: row.applicantId,
    };

    setStructureType(row.structureType);
    setStructureName(row.structureName);
    setDropdownValue(row.percentFixed);
    setValue(row.value.toString());
    setPayStructId(row.payStructId);

    // Only set editMode to true if we're in the second tab (tabValue === 1)
    // This ensures first tab stays in "Post" mode even when editing dialog table rows
    if (tabValue === 1) {
      setEditMode(true);
    }

    // Remove the edited row from the table
    const newData = dialogStructureData.filter((_, i) => i !== index);
    setDialogStructureData(newData);
    updateTotalCtc(newData);
  };

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          flexGrow: 1,
          boxShadow: "none",
          border: "none",
          height: "100vh",
          backgroundColor: "transparent",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* <Dialog
          open={loading}
          onClose={() => setLoading(false)}
          aria-labelledby="loading-dialog-title"
        >
          <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <CircularProgress color="primary" />
            <Typography variant="h6" style={{ marginTop: "20px" }}>
              Loading, please wait...
            </Typography>
          </DialogContent>
        </Dialog> */}

        <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="delete-dialog-title">
          <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
          <DialogContent>Are you sure you want to delete this structure?</DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleDeleteStructure}>Delete</Button>
          </DialogActions>
        </Dialog>

        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", mt: 0 }}>
          <ResponsiveTabs
            tabs={tabs}
            activeTab={tabValue}
            onChange={handleTabChange}
            labelColor="#1890ff"
            bgColor="#f0f7ff"
          />

          <Box
            sx={{
              mt: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              height: "calc(100vh - 120px)",
            }}
          >
            {tabValue === 0 ? (
              <Paper
                sx={{
                  p: 2,
                  borderRadius: "15px",
                  backgroundColor: "#ffffff",
                  width: "100%",
                  maxWidth: "1600px",
                  mx: "auto",
                  height: "90%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <StyledAgGridContainer
                  className="ag-theme-alpine"
                  style={{
                    flexGrow: 1,
                    width: "100%",
                    height: "calc(75vh - 100px)",
                    minHeight: "200px",
                  }}
                >
                  <AgGridReact
                    columnDefs={columnDefsTab1}
                    rowData={unmappedEmployeeData}
                    pagination={true}
                    paginationPageSize={10}
                    defaultColDef={{
                      flex: 1,
                      minWidth: 150,
                      resizable: true,
                      sortable: true,
                      filter: true,
                    }}
                    rowHeight={48}
                    headerHeight={48}
                    animateRows={true}
                    enableCellTextSelection={true}
                    suppressRowClickSelection={true}
                    onGridReady={(params) => {
                      params.api.sizeColumnsToFit();
                    }}
                    onFirstDataRendered={(params) => {
                      params.api.sizeColumnsToFit();
                    }}
                  />
                </StyledAgGridContainer>
              </Paper>
            ) : (
              <Paper
                sx={{
                  p: 2,
                  borderRadius: "15px",
                  backgroundColor: "#ffffff",
                  width: "100%",
                  maxWidth: "1600px",
                  mx: "auto",
                  height: "90%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <StyledAgGridContainer
                  className="ag-theme-alpine"
                  style={{
                    flexGrow: 1,
                    width: "100%",
                    height: "calc(75vh - 100px)",
                    minHeight: "200px",
                  }}
                >
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={structureData}
                    pagination={true}
                    paginationPageSize={10}
                    defaultColDef={{
                      flex: 1,
                      minWidth: 150,
                      resizable: true,
                      sortable: true,
                      filter: true,
                    }}
                    rowHeight={48}
                    headerHeight={48}
                    animateRows={true}
                    enableCellTextSelection={true}
                    suppressRowClickSelection={true}
                    onGridReady={(params) => {
                      params.api.sizeColumnsToFit();
                    }}
                    onFirstDataRendered={(params) => {
                      params.api.sizeColumnsToFit();
                    }}
                  />
                </StyledAgGridContainer>
              </Paper>
            )}
          </Box>
        </Box>

        <StyledSnackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <StyledAlert onClose={handleClose} severity={alertType}>
            {message}
          </StyledAlert>
        </StyledSnackbar>
        <Dialog
          open={openStructureDialog}
          onClose={handleCloseStructureDialog}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 4,
              overflowY: "hidden",
              background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              maxHeight: "85vh",
              width: "95vw",
              maxWidth: "1600px",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              backdropFilter: "blur(10px)",
              "@media (max-width: 900px)": {
                width: "100vw",
                height: "100vh",
                maxHeight: "100vh",
                margin: 0,
                borderRadius: 0,
              },
            },
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #E59400 0%, #D48800 100%)",
              color: "white",
              p: 2,
              position: "relative",
              boxShadow: "0 4px 20px rgba(229, 148, 0, 0.4)",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%)",
                width: "calc(100% - 60px)",
                height: "2px",
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    background: "rgba(255,255,255,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255,255,255,0.3)",
                  }}
                >
                  {editMode ? (
                    <EditIcon sx={{ fontSize: 24, color: "white" }} />
                  ) : (
                    <AddIcon sx={{ fontSize: 24, color: "white" }} />
                  )}
                </Box>
                <Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 800,
                      color: "white",
                      letterSpacing: "-0.5px",
                      textShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  >
                    {editMode ? "Update Structure Details" : "Post Structure Details"}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      opacity: 0.9,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      mt: 0.5,
                    }}
                  >
                    <InfoIcon sx={{ fontSize: 14 }} />
                    Manage salary structure components
                  </Typography>
                </Box>
              </Box>
              <IconButton
                onClick={handleCloseStructureDialog}
                sx={{
                  color: "white",
                  background: "rgba(255,255,255,0.2)",
                  backdropFilter: "blur(10px)",
                  width: 40,
                  height: 40,
                  border: "1px solid rgba(255,255,255,0.3)",
                  "&:hover": {
                    background: "rgba(255,255,255,0.3)",
                    transform: "rotate(90deg) scale(1.1)",
                    boxShadow: "0 0 20px rgba(255,255,255,0.4)",
                  },
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          {/* Main Content - Split Screen Layout */}
          <Box
            sx={{
              display: "flex",
              height: "calc(85vh - 160px)",
              "@media (max-width: 900px)": { flexDirection: "column", height: "auto" },
            }}
          >
            {/* Left Panel - Form */}
            <Box
              sx={{
                flex: 1,
                p: 3,
                borderRight: "1px solid rgba(0,0,0,0.08)",
                overflowY: "auto",
                "@media (max-width: 900px)": {
                  borderRight: "none",
                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                },
              }}
            >
              {/* Applicant Info */}
              <Paper
                elevation={0}
                sx={{
                  p: 2.5,
                  mb: 3,
                  borderRadius: 2,
                  background:
                    "linear-gradient(135deg, rgba(229, 148, 0, 0.05) 0%, rgba(212, 136, 0, 0.03) 100%)",
                  border: "1px solid rgba(229, 148, 0, 0.2)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1.5 }}>
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: 1,
                      background: "linear-gradient(135deg, #E59400 0%, #D48800 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon sx={{ fontSize: 18, color: "white" }} />
                  </Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#070707" }}>
                    Applicant Information
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Applicant Name"
                      value={selectedEmployee?.employeeName || ""}
                      fullWidth
                      disabled
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                          background: "rgba(255,255,255,0.8)",
                          "&.Mui-disabled": {
                            background: "rgba(0,0,0,0.02)",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Annual CTC"
                      value={
                        selectedEmployee?.ctcPerYear
                          ? formatNumberWithCommas(selectedEmployee.ctcPerYear.toFixed(2))
                          : ""
                      }
                      fullWidth
                      disabled
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                          background: "rgba(255,255,255,0.8)",
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 22,
                                height: 22,
                                borderRadius: "50%",
                                background: "linear-gradient(135deg, #E59400 0%, #D48800 100%)",
                                color: "white",
                                fontSize: 11,
                              }}
                            >
                              ₹
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>

              {/* Structure Input Form */}
              <Paper
                elevation={0}
                sx={{
                  p: 2.5,
                  mb: 3,
                  borderRadius: 2,
                  background: "white",
                  border: "1px solid rgba(0,0,0,0.1)",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 2.5, gap: 1.5 }}>
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: 1,
                      background: "linear-gradient(135deg, #E59400 0%, #D48800 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AddIcon sx={{ fontSize: 18, color: "white" }} />
                  </Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#070707" }}>
                    Add Structure Component
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      options={structureTypeOptions}
                      getOptionLabel={(option) => option.label}
                      value={
                        structureTypeOptions.find((option) => option.value === structureType) ||
                        null
                      }
                      onChange={(event, value) => setStructureType(value ? value.value : "")}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Structure Type"
                          required
                          placeholder="Select type"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 1,
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      options={filteredStructures}
                      getOptionLabel={(option) => option.label}
                      value={
                        filteredStructures.find((option) => option.label == structureName) || null
                      }
                      onChange={handleStructureNameChange}
                      size="small"
                      disabled={!structureType}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Structure Name"
                          required
                          placeholder="Select structure"
                          disabled={!structureType}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 1,
                              background: !structureType ? "rgba(0,0,0,0.02)" : "white",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Value"
                      value={value}
                      onChange={handleValueChange}
                      fullWidth
                      required
                      type="number"
                      inputProps={{ min: 0, step: "0.01" }}
                      disabled={!structureType}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                          background: !structureType ? "rgba(0,0,0,0.02)" : "white",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      onClick={handleAddToTable}
                      disabled={!structureType || !structureName || !value}
                      startIcon={<AddIcon />}
                      sx={{
                        width: "100%",
                        height: 42,
                        borderRadius: 1,
                        background: "linear-gradient(135deg, #E59400 0%, #D48800 100%)",
                        color: "white",
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "0.95rem",
                        "&:hover": {
                          background: "linear-gradient(135deg, #D48800 0%, #E59400 100%)",
                          transform: "translateY(-1px)",
                          boxShadow: "0 4px 12px rgba(229, 148, 0, 0.4)",
                        },
                        "&:disabled": {
                          background: "rgba(0,0,0,0.12)",
                          color: "rgba(0,0,0,0.26)",
                        },
                        transition: "all 0.2s ease",
                      }}
                    >
                      Add to List
                    </Button>
                  </Grid>
                </Grid>
              </Paper>

              {/* Quick Stats */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  background:
                    "linear-gradient(135deg, rgba(229, 148, 0, 0.08) 0%, rgba(212, 136, 0, 0.04) 100%)",
                  border: "1px solid rgba(229, 148, 0, 0.15)",
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography variant="caption" color="text.secondary">
                      Components Added
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#E59400" }}>
                      {dialogStructureData.length}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption" color="text.secondary">
                      Total Value
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#070707" }}>
                      ₹{formatNumberWithCommas(totalCtc.toFixed(2))}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Box>

            {/* Right Panel - Table & Summary */}
            <Box
              sx={{
                flex: 1.5,
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
              }}
            >
              {/* Table Header */}
              <Box
                sx={{
                  p: 2,
                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                  background: "rgba(229, 148, 0, 0.05)",
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      color: "#070707",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <ViewListIcon sx={{ fontSize: 20, color: "#E59400" }} />
                    Structure Components
                  </Typography>
                  <Box
                    sx={{
                      px: 1,
                      py: 0.1,
                      borderRadius: 20,
                      background: "rgba(229, 148, 0, 0.1)",
                      border: "1px solid rgba(229, 148, 0, 0.2)",
                    }}
                  >
                    <Typography variant="caption" sx={{ fontWeight: 700, color: "#E59400" }}>
                      {dialogStructureData.length} items
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Table */}
              <Box sx={{ flex: 1, overflow: "auto" }}>
                <TableContainer>
                  <Table size="small" sx={{ minWidth: 650 }}>
                    <TableBody>
                      <TableRow sx={{ background: "rgba(229, 148, 0, 0.08)", position: "sticky" }}>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            py: 1.5,
                            color: "#070707",
                            borderBottom: "2px solid rgba(229, 148, 0, 0.3)",
                          }}
                        >
                          Type
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            py: 1.5,
                            color: "#070707",
                            borderBottom: "2px solid rgba(229, 148, 0, 0.3)",
                          }}
                        >
                          Name
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            py: 1.5,
                            color: "#070707",
                            borderBottom: "2px solid rgba(229, 148, 0, 0.3)",
                          }}
                        >
                          Calculation
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            py: 1.5,
                            color: "#070707",
                            borderBottom: "2px solid rgba(229, 148, 0, 0.3)",
                            textAlign: "right",
                          }}
                        >
                          Value
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            py: 1.5,
                            color: "#070707",
                            borderBottom: "2px solid rgba(229, 148, 0, 0.3)",
                            textAlign: "right",
                          }}
                        >
                          Amount
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            py: 1.5,
                            color: "#070707",
                            borderBottom: "2px solid rgba(229, 148, 0, 0.3)",
                            textAlign: "center",
                          }}
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                      {dialogStructureData.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:hover": { background: "rgba(229, 148, 0, 0.03)" },
                            "&:nth-of-type(even)": { background: "rgba(0,0,0,0.01)" },
                          }}
                        >
                          <TableCell sx={{ py: 1.5, fontSize: "0.8125rem" }}>
                            {row.structureType}
                          </TableCell>
                          <TableCell sx={{ py: 1.5, fontSize: "0.8125rem" }}>
                            {row.structureName}
                          </TableCell>
                          <TableCell sx={{ py: 1.5 }}>
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                px: 1,
                                py: 0.25,
                                borderRadius: 0.5,
                                background:
                                  row.percentFixed === "PERCENT"
                                    ? "rgba(33, 150, 243, 0.1)"
                                    : "rgba(76, 175, 80, 0.1)",
                                color: row.percentFixed === "PERCENT" ? "#2196F3" : "#4CAF50",
                                fontSize: "0.7rem",
                                fontWeight: 600,
                              }}
                            >
                              {row.percentFixed}
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{
                              py: 1.5,
                              textAlign: "right",
                              fontSize: "0.8125rem",
                              fontWeight: 600,
                            }}
                          >
                            {row.percentFixed === "PERCENT"
                              ? `${parseFloat(row.value).toFixed(2)}%`
                              : `₹${formatNumberWithCommas(parseFloat(row.value).toFixed(2))}`}
                          </TableCell>
                          <TableCell
                            sx={{
                              py: 1.5,
                              textAlign: "right",
                              fontSize: "0.8125rem",
                              fontWeight: 700,
                              color: "#E59400",
                            }}
                          >
                            ₹{formatNumberWithCommas(parseFloat(row.amount || 0).toFixed(2))}
                          </TableCell>
                          <TableCell sx={{ py: 1.5, textAlign: "center" }}>
                            <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center" }}>
                              <IconButton
                                onClick={() => handleEditTableRow(index)}
                                size="small"
                                sx={{
                                  width: 28,
                                  height: 28,
                                  background: "rgba(33, 150, 243, 0.1)",
                                  color: "#2196F3",
                                  "&:hover": { background: "#2196F3", color: "#ffffff" },
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                onClick={() => handleRemoveFromTable(index)}
                                size="small"
                                sx={{
                                  width: 28,
                                  height: 28,
                                  background: "rgba(244, 67, 54, 0.1)",
                                  color: "#F44336",
                                  "&:hover": { background: "#F44336", color: "#ffffff" },
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Fixed Summary Footer */}
              <Box
                sx={{
                  p: 1.5,
                  borderTop: "1px solid rgba(0,0,0,0.08)",
                  background:
                    "linear-gradient(135deg, rgba(229, 148, 0, 0.1) 0%, rgba(212, 136, 0, 0.05) 100%)",
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                >
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 600,
                        color: "#070707",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <CheckCircleIcon sx={{ fontSize: "1rem", color: "#E59400" }} />
                      Total Annual CTC
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "text.secondary",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <CalculateIcon sx={{ fontSize: 14 }} />
                      Sum of all structure components
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: "right" }}>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 800,
                        color: "#E59400",
                        letterSpacing: "-0.5px",
                        textShadow: "0 2px 4px rgba(229, 148, 0, 0.2)",
                      }}
                    >
                      ₹{formatNumberWithCommas(totalCtc.toFixed(2))}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 500 }}>
                      per annum
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Dialog Actions */}
          <DialogActions
            sx={{
              p: 2,
              background: "rgba(0,0,0,0.02)",
              borderTop: "1px solid rgba(0,0,0,0.08)",
              "@media (max-width: 600px)": {
                flexDirection: "column",
                gap: 1.5,
              },
            }}
          >
            <Button
              onClick={handleCloseStructureDialog}
              variant="outlined"
              size="small"
              sx={{
                px: 3,
                py: 1,
                borderRadius: 1,
                border: "1px solid rgba(0,0,0,0.2)",
                color: "text.secondary",
                fontWeight: 600,
                textTransform: "none",
                fontSize: "0.95rem",
                "&:hover": {
                  background: "rgba(0,0,0,0.04)",
                  border: "1px solid rgba(0,0,0,0.3)",
                },
                transition: "all 0.2s ease",
                "@media (max-width: 600px)": {
                  width: "100%",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleAddStructure}
              disabled={dialogStructureData.length === 0}
              startIcon={editMode ? <SaveIcon /> : <AddIcon />}
              size="small"
              sx={{
                px: 4,
                py: 1,
                borderRadius: 1,
                background: "linear-gradient(135deg, #E59400 0%, #D48800 100%)",
                color: "white",
                fontWeight: 700,
                textTransform: "none",
                fontSize: "0.95rem",
                boxShadow: "0 4px 12px rgba(229, 148, 0, 0.4)",
                "&:hover": {
                  background: "linear-gradient(135deg, #D48800 0%, #E59400 100%)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 6px 16px rgba(229, 148, 0, 0.5)",
                },
                "&:disabled": {
                  background: "rgba(0,0,0,0.12)",
                  color: "rgba(0,0,0,0.26)",
                  boxShadow: "none",
                },
                transition: "all 0.2s ease",
                "@media (max-width: 600px)": {
                  width: "100%",
                },
              }}
            >
              {editMode ? "Update Structure" : "Save Structure"}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </DashboardLayout>
  );
}
